import { render } from "./CaseView.vue?vue&type=template&id=fb14ee9c&scoped=true&ts=true"
import script from "./CaseView.vue?vue&type=script&lang=ts"
export * from "./CaseView.vue?vue&type=script&lang=ts"

import "./CaseView.vue?vue&type=style&index=0&id=fb14ee9c&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb14ee9c"]])

export default __exports__